export default __webpack_public_path__ + "static/media/1929.28ed907a.png";